var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import DynamicDialog from '../components/Dialog';
import history from '../history';
import React from 'react';
import { ApplicationContext } from '../context';
import { ColorType, StyleType } from '../api';
import { compilePatchOperations, compilePattern } from '../util';
import { Container } from './di';
import { Subject } from 'rxjs';
export var CANCEL = Symbol();
export var WARNING_CONFIRMATION = Symbol();
export var Refresh$ = new Subject();
export var ContentPatch$ = new Subject();
export var Modal$ = new Subject();
export var ContentAnchor$ = new Subject();
export function compileUrl(url, dataState, variables) {
    return (dataState ? dataState.compilePattern(url, variables) : compilePattern(url, dataState, Container.locale));
}
function fixUrl(url) {
    return (url.startsWith('/') ? url : "/" + url);
}
export function handleAction(action, data, dataState, options) {
    var _this = this;
    if (options === void 0) { options = {}; }
    return new Promise(function (resolve, reject) {
        if (action.navigateTo) {
            var compiledUrl = compilePattern(action.navigateTo, data);
            history.push(fixUrl(compiledUrl));
        }
        else if (action.contextSpecific) {
            if (options.context) {
                options.context.broadcast.next({
                    type: 'SpecificAction',
                    data: action.contextSpecific
                });
            }
        }
        else if (action.openDialog) {
            // this.dialogs.open(LayoutDialogComponent, new LayoutDialogOptions(action.openDialog, data || {}));
            if (dataState == null) {
                dataState = Container.createDataStateService();
            }
            var ref_1;
            ref_1 = Container.modal.open(React.createElement(ApplicationContext.Provider, { value: options.context },
                React.createElement(DynamicDialog, { onCancel: function () { return ref_1.close(); }, control: action.openDialog, dataState: dataState })));
        }
        else if (action.serverDataPatch) {
            var compiledUrl = compileUrl(action.serverDataPatch.endpoint, dataState);
            Container.http.post(compiledUrl, data, {
                $confirmation: options.confirmation
            })
                .then(function (response) {
                resolve(response);
            }, function (response) { return __awaiter(_this, void 0, void 0, function () {
                var _a, handler, hasWarnings;
                var _this = this;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, handleInvalidServerResponse(response)];
                        case 1:
                            _a = _b.sent(), handler = _a.handler, hasWarnings = _a.hasWarnings;
                            if (hasWarnings) {
                                handler.close$.subscribe(function (result) { return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        if (result == WARNING_CONFIRMATION) {
                                            handleAction(action, data, dataState, {
                                                confirmation: true
                                            }).then(function (ok) {
                                                resolve(ok);
                                            }, function (fail) {
                                                reject(fail);
                                            });
                                        }
                                        else {
                                            reject(response);
                                        }
                                        return [2 /*return*/];
                                    });
                                }); });
                            }
                            else {
                                reject(response);
                            }
                            return [2 /*return*/];
                    }
                });
            }); });
        }
        else if (action.modelPatch) {
            var compiledUrl = compileUrl(action.modelPatch.endpoint, dataState);
            var operations = (dataState ?
                compilePatchOperations(action.modelPatch.patch, dataState.record) :
                compilePatchOperations(action.modelPatch.patch, data));
            Container.http.patch(compiledUrl, operations)
                .then(function (response) {
                Refresh$.next();
                resolve(response);
            }, function (response) {
                handleInvalidServerResponse(response);
                reject(response);
            });
        }
        else if (action.deleteUrl) {
            var compiledUrl = compileUrl(action.deleteUrl, dataState);
            Container.http.delete(compiledUrl)
                .then(function (response) {
                Refresh$.next();
                resolve(response);
            }, function (response) {
                handleInvalidServerResponse(response);
                reject(response);
            });
        }
        else if (action.actionUrl) {
            var compiledUrl = compileUrl(action.actionUrl, dataState);
            var actionData = null;
            if (action.actionData) {
                actionData = (dataState ? dataState.compileQuery(action.actionData) : actionData);
            }
            Container.http.post(compiledUrl, __assign(__assign({}, (data || {})), (actionData || {})), {
                $confirmation: options.confirmation
            })
                .then(function (response) {
                resolve(response);
            }, function (response) { return __awaiter(_this, void 0, void 0, function () {
                var _a, handler, hasWarnings, error_1;
                var _this = this;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _b.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, handleInvalidServerResponse(response)];
                        case 1:
                            _a = _b.sent(), handler = _a.handler, hasWarnings = _a.hasWarnings;
                            if (hasWarnings) {
                                handler.close$.subscribe(function (result) { return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        if (result == WARNING_CONFIRMATION) {
                                            handleAction(action, data, dataState, {
                                                confirmation: true
                                            }).then(function (ok) {
                                                resolve(ok);
                                            }, function (fail) {
                                                reject(fail);
                                            });
                                        }
                                        else {
                                            reject(response);
                                        }
                                        return [2 /*return*/];
                                    });
                                }); });
                            }
                            else {
                                reject(response);
                            }
                            return [3 /*break*/, 3];
                        case 2:
                            error_1 = _b.sent();
                            reject(error_1);
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            }); });
        }
    });
}
export function handleActionResponse(response, dataState) {
    if (response.$action) {
        return handleActionResponse(response.$action, dataState);
    }
    if (response.refresh) {
        response.refresh
            .forEach(function (key) { return Refresh$.next(key); });
    }
    if (response.message) {
        // this.dialogs.alert(response.message);
    }
    if (response.contentPatches) {
        response.contentPatches
            .forEach(function (cp) { return ContentPatch$.next(cp); });
    }
    if (response.dataPatch && dataState) {
        if (response.dataPatch.operations) {
            dataState.patch(response.dataPatch.operations);
        }
        else if (response.dataPatch.merge) {
            dataState.mergeWith(response.dataPatch.merge);
        }
    }
    if (response.openDialog) {
        // this.dialogs.open(LayoutDialogComponent, new LayoutDialogOptions(response.openDialog, response.dataState));
    }
    if (response.notification) {
        if (response.notification.layout) {
            // this.dialogs.open(LayoutDialogComponent, new LayoutDialogOptions(response.notification.layout, {}));
        }
        else {
            alert(response.notification.description);
        }
    }
    if (response.navigateTo) {
        history.push(fixUrl(response.navigateTo));
    }
}
export function resolveData(resolveDefinition, targetDataState, options) {
    var _this = this;
    if (options === void 0) { options = {}; }
    return new Promise(function (resolve, reject) {
        if (resolveDefinition) {
            if (typeof resolveDefinition == 'string') {
                console.log(history);
                var url = compilePattern(resolveDefinition, {
                    $params: options.params,
                    $query: options.query
                });
                Container.http.get(url)
                    .then(function (data) {
                    targetDataState.setRecord(data);
                    resolve();
                }, function (error) { return reject(error); });
            }
            else {
                targetDataState.setRecord({});
                Promise.all(Object.keys(resolveDefinition)
                    .map(function (resolveName) { return __awaiter(_this, void 0, void 0, function () {
                    var url, compiledUrl, data;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                url = resolveDefinition[resolveName];
                                compiledUrl = (targetDataState ? targetDataState.compilePattern(url, {
                                    $params: options.params,
                                    $query: options.query
                                }) : compilePattern(url, {
                                    $params: options.params,
                                    $query: options.query
                                }));
                                return [4 /*yield*/, Container.http.get(compiledUrl)];
                            case 1:
                                data = _a.sent();
                                targetDataState.set(resolveName, data);
                                return [2 /*return*/, data];
                        }
                    });
                }); }))
                    .then(function () {
                    resolve();
                });
            }
        }
        else {
            resolve();
        }
    });
}
export function handleInvalidServerResponse(response) {
    if (response.status == 400) {
        return handleInvalidValidationResult(response.error.errors);
    }
    else {
        // this.dialogs.alert('Akce se nezdařila, zkuste to později.');
        throw response;
    }
}
export function handleInvalidValidationResult(validationErrors) {
    return __awaiter(this, void 0, void 0, function () {
        var handler, buttons, title, errors, warnings;
        return __generator(this, function (_a) {
            errors = validationErrors
                .filter(function (ve) { return ve.constraints != null; });
            warnings = validationErrors
                .filter(function (ve) { return ve.warnings != null; });
            if (warnings.length > 0 && errors.length == 0) {
                title = 'Upozornění';
                buttons = [{
                        label: 'Cancel',
                        styleType: StyleType.Text,
                        callback: function () {
                            handler.close(CANCEL);
                        }
                    },
                    {
                        label: 'Pokračovat přes upozornění',
                        colorType: ColorType.Primary,
                        callback: function () {
                            handler.close(WARNING_CONFIRMATION);
                        }
                    }];
            }
            else if (errors.length > 0) {
                title = 'Akce není povolena';
                buttons = [{
                        label: 'OK',
                        colorType: ColorType.Primary,
                        callback: function () {
                            handler.close();
                        }
                    }];
            }
            // handler = await this.dialogs.buttons({
            // 	title: title,
            // 	componentType: ValidationResultViewComponent,
            // 	componentOptions: new ValidationResultViewOptions(validationErrors),
            // 	buttons: buttons
            // });
            return [2 /*return*/, {
                    handler: handler,
                    hasErrors: errors.length > 0,
                    hasWarnings: warnings.length > 0
                }];
        });
    });
}
//# sourceMappingURL=actions.js.map